import React from 'react'
import { t } from '../../../i18n'
import Icon from '../../shared/icon'
import { CommandButton, ControlGroupKey, SessionPayload } from '../types'
import ActionButton from './ActionButton'
import SessionButton from './SessionButton'

const scope = 'controls'

const buttonClassName =
  'btn btn-primary w-100 h-100 d-inline-flex align-items-center justify-content-center gap-2 controls-actions-btn-tall'

interface Props {
  groupKey: ControlGroupKey
  commands: CommandButton[]
  cardClassName?: string
  session: SessionPayload
  commandsLoaded: boolean
  sessionLoaded: boolean
  countdown: number
  sessionBusy: boolean
  onStartSession: () => void
  onFinishSession: () => void
}

const commandButton = (command: CommandButton | undefined, iconName: string, variant = 'btn-primary') => {
  if (!command) return <div className="text-muted fst-italic">—</div>

  return (
    <ActionButton
      command={command}
      buttonClassName={buttonClassName.replace('btn-primary', variant)}
      icon={<Icon name={iconName} color="currentColor" />}
    />
  )
}

const RobotAndGripperLayout = ({
  groupKey,
  commands,
  cardClassName,
  session,
  commandsLoaded,
  sessionLoaded,
  countdown,
  sessionBusy,
  onStartSession,
  onFinishSession,
}: Props) => {
  // A pending pause is cancelled with Resume too: it clears the request before the robot confirms it.
  const robotButton = session.robot_paused || session.robot_pausing
    ? commandButton(commands.find(c => c.command === 'resume_robot'), 'play')
    : commandButton(commands.find(c => c.command === 'pause_robot'), 'circlePause')

  const clearGripperButton = commandButton(commands.find(c => c.command === 'clear_gripper'), 'brush')

  const startRobot = commands.find(c => c.command === 'start_robot')
  const emergencyButton = startRobot
    ? commandButton(startRobot, 'play', 'btn-success')
    : commandButton(commands.find(c => c.command === 'emergency_stop'), 'warning', 'btn-danger')

  return (
    <div className={cardClassName ?? 'card mb-3'}>
      <div className="card-body">
        <h6 className="card-title mb-3">{t(`groups.${groupKey}`, { scope })}</h6>
        <div className="controls-actions-flex">
          <div className="controls-actions-flex-item">{robotButton}</div>
          <div className="controls-actions-flex-item">
            {commandsLoaded && sessionLoaded ? (
              <SessionButton
                session={session}
                countdown={countdown}
                busy={sessionBusy}
                onStart={onStartSession}
                onFinish={onFinishSession}
              />
            ) : (
              <div className="text-muted fst-italic">—</div>
            )}
          </div>
          <div className="controls-actions-flex-item">{clearGripperButton}</div>
          <div className="controls-actions-flex-item">{emergencyButton}</div>
        </div>
      </div>
    </div>
  )
}

export default RobotAndGripperLayout
